// --- BASE ---
import React from 'react';

// --- INTERFACES ---
import { TypeOptions } from 'react-toastify';
import { IMappedErrors } from './Interfaces';

export function convertTicks(message: string | null | undefined) {
	if (message === null || message === undefined) {
		return <></>;
	}

	const re = new RegExp('(`.+?`)', 'gi');

	const messagePieces: Array<JSX.Element> = [];

	if (typeof message === 'string') {
		const splitMessage = message.split(re);

		// Loop through the split message pieces and look for `blah blah` to replace with tags.
		for (let i = 0; i < splitMessage.length; i++) {
			let value = splitMessage[i];

			if (value.match(/^`(.+?)`$/g)) {
				value = value.replace(/`/g, '');
				messagePieces.push(<strong key={i}>{value}</strong>);
			} else {
				messagePieces.push(<span key={i}>{value}</span>);
			}
		}
	}

	return <>{messagePieces}</>;
}

export function convertToastStatus(status: string | null | undefined): TypeOptions {
	if (status === null || status === undefined) {
		return 'error';
	}

	return ['default', 'error', 'info', 'success', 'warning'].includes(status) ? (status as TypeOptions) : 'error';
}

export function checkExpired(result: object): void {
	const status = 'status' in result && typeof result.status === 'string' && result.status !== null ? result.status : 'error';

	if (status === 'expired') {
		// Remove the token from localStorage so it doesn't keep looping to the expired page.
		localStorage.removeItem('token');

		// Redirect to the expired page.
		window.location.assign('/expired');
	}

	const errors = 'errors' in result && typeof result.errors === 'object' && result.errors !== null ? result.errors : null;

	if (errors !== null && 'access_token' in errors && typeof errors.access_token === 'string' && errors.access_token === 'expired') {
		window.location.assign('/expired');
	}

	const data = 'data' in result && typeof result.data === 'object' && result.data !== null ? result.data : null;

	const accountStatus = data !== null && 'status' in data && typeof data.status === 'string' && data.status !== null ? data.status : null;

	switch (accountStatus) {
		case 'unverified':
			window.location.assign('/verify');
			break;

		case 'pending':
			window.location.assign('/pending');
			break;

		default:
	}
}

export function drawErrorMessages(displayErrors: string[]) {
	if (displayErrors.length === 0) {
		return;
	}

	return (
		<ul>
			{displayErrors.map(function (row) {
				return (
					<li className="danger">
						<small>{row}</small>
					</li>
				);
			})}
		</ul>
	);
}

export function fileSize(value: string | number | null | undefined): string | null {
	if (typeof value === 'undefined') {
		return null;
	}

	if (value === null) {
		return null;
	}

	if (typeof value === 'string') {
		value = parseInt(value, 10);
	}

	const units = 1024;
	let counter = 0;

	while (value >= units || -value >= units) {
		value /= units;
		counter++;
	}

	return (counter ? value.toFixed(1) + ' ' : value) + ' KMGTPEZY'[counter] + 'B';
}

export function highlightWords(val: string | null, search: string | null): JSX.Element {
	// console.log('val', val, typeof val, 'search', search, typeof search);

	if (typeof search === 'undefined' || search === null || search === '') {
		return typeof val === 'undefined' || val === null ? <></> : <>{val}</>;
	}

	if (typeof val === 'undefined' || val === null) {
		return <></>;
	}

	// const regex = new RegExp('(' + search.toString() + ')', 'gi');
	const regex = new RegExp(`(${search})`, 'gi');

	// Split text on highlight term, include term itself into parts, ignore case
	const parts = val.toString().split(regex);

	return (
		<span>
			{parts.map((part, idx) => {
				return part.toLowerCase() === search.toLowerCase() ? <mark key={idx}>{part}</mark> : <span key={idx}>{part}</span>;
			})}
		</span>
	);
}

export function parseMappedErrors(errors: any, section: string) {
	const displayErrors: string[] = [];
	const mappedErrors: IMappedErrors = [];

	if (errors !== null && section in errors && Array.isArray(errors[section]) && errors[section].length > 0) {
		for (const row of errors[section]) {
			if (typeof row === 'string' && row !== null) {
				if (row.includes(';') || row.includes('|')) {
					const splitErrorList = row.split(';');

					for (const indexErrorList of splitErrorList) {
						const splitError = indexErrorList.split('|');
						const rowIndex: number = parseInt(splitError[0], 10);
						const rowFieldName: string = splitError[1];
						const rowFieldErrorMessage: string = splitError[2];

						if (typeof mappedErrors[rowIndex] !== 'object' || mappedErrors[rowIndex] === null) {
							mappedErrors[rowIndex] = {};
						}

						if (typeof mappedErrors[rowIndex] === 'object' && typeof mappedErrors[rowIndex][splitError[1]] === 'object') {
							console.log('Already exists');
						}

						mappedErrors[rowIndex][rowFieldName] = [rowFieldErrorMessage];
						displayErrors.push(rowFieldErrorMessage);
					}
				} else {
					displayErrors.push(row);
				}
			}
		}
	}

	return [displayErrors, mappedErrors];
}

export function round(num: number, decimalPlaces = 0) {
	if (num < 0) {
		return -round(-num, decimalPlaces);
	}

	const p = Math.pow(10, decimalPlaces);

	const n: number = parseFloat((num * p).toPrecision(15));

	return Math.round(n) / p;
}

// Convert the error fields into the same format as errors, so we don't have to build a second item.
export function translateCorrectionToError(errorFields: object) {
	console.log({ errorFields });

	const newErrorFields = {};
	Object.keys(errorFields).forEach((key) => {
		// console.log({ key });

		if (key.includes('|')) {
			const splitKey = key.split('|');
			console.log({ splitKey });

			if (splitKey.length === 3) {
				const mainField: string = splitKey[0];
				const errorIndex: number = parseInt(splitKey[1], 10);
				const errorField: string = splitKey[2];

				if (typeof newErrorFields[mainField] !== 'object' || !Array.isArray(newErrorFields[mainField])) {
					newErrorFields[mainField] = [];
				}

				if (Array.isArray(newErrorFields[mainField])) {
					newErrorFields[mainField].push(`${errorIndex}|${errorField}|${errorFields[key]}`);
				}
			}
		} else {
			newErrorFields[key] = errorFields[key];
		}
	});

	return newErrorFields;
}
